import { render, staticRenderFns } from "./TempoCanvas.vue?vue&type=template&id=3c43bf92&"
import script from "./TempoCanvas.vue?vue&type=script&lang=ts&"
export * from "./TempoCanvas.vue?vue&type=script&lang=ts&"
import style0 from "./TempoCanvas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports